import { Guid } from '@web/utils';

export class WarehouseOwnerCollectionItem {
  public constructor(
    private readonly data: {
      id: Guid;
      slug: string;
      label: string;
      createdAt: Date;
      canBeEdited: boolean;
      canBeRemoved: boolean;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get label(): string {
    return this.data.label;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }
}
